export default function GlassCard({ children, className = "" }) {
  return (
    <div
      className={`
        bg-white/50 backdrop-blur-xl
        border border-white/70
        rounded-2xl shadow-md
        ${className}
      `}
    >
      {children}
    </div>
  );
}